// component for deleting any entity

import React, { FC } from 'react';
import TwDialog from '../TwDialog/TwDialog';
import { ReactComponent as Warning } from '../../assets/icons/warning.svg';
import { TwButton, TwButtonType } from '../TwButtons/TwButtons';

interface TwDeleteModalProps {
  open: boolean;
  entityName: string;
  onClickClose: () => void;
  onDelete: () => void;
  isDeleting?: boolean;
}

const TwDeleteModal: FC<TwDeleteModalProps> = ({
  open,
  entityName,
  onClickClose,
  onDelete,
  isDeleting = false
}): JSX.Element => {
  return (
    <TwDialog open={open} title={`Delete ${entityName}`} onClickClose={onClickClose}>
      <div className="warning">
        <Warning />
        <p className="warning__message">
          Are you sure you want to delete this {entityName}? <br />
          You can&apos;t undo this action.
        </p>
        <div className="warning__actions">
          <TwButton
            fullwidth={false}
            label="Cancel"
            type={TwButtonType.secondary}
            action={onClickClose}
          />
          <TwButton
            fullwidth={false}
            label="Delete"
            type={TwButtonType.negative}
            action={onDelete}
            disabled={isDeleting}
          />
        </div>
      </div>
    </TwDialog>
  );
};

export default TwDeleteModal;
